import { render, staticRenderFns } from "./rogressBar.vue?vue&type=template&id=5b4e54d7&scoped=true"
import script from "./rogressBar.vue?vue&type=script&lang=js"
export * from "./rogressBar.vue?vue&type=script&lang=js"
import style0 from "./rogressBar.vue?vue&type=style&index=0&id=5b4e54d7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b4e54d7",
  null
  
)

export default component.exports